import { flog } from '@zambezi/caballo-vivo';
import { catchAndStowError as baseCatchAndStowError, restoreWarning } from '@apiEnabler/api-enabler-common/lib/errors';
import { map, take, tap } from 'rxjs/operators';
import { userAuthNMethod$ } from './intents';
import { channelIdToJourneyType } from './consent-utils';
export function catchAndStowError(source$) {
  return source$.pipe(baseCatchAndStowError(function (error) {
    emitUserAuthNMethod(error);
    throw error;
  }));
}
export var restore = restoreWarning(function (error, store$) {
  return store$.pipe(take(1), tap(function () {
    emitUserAuthNMethod(error);
  }), map(function (state) {
    return state.set('error', error).update(updateJourneyTypeIfPresent(error)).delete('loading').delete('modal');
  }), flog('Error recovered'));
});
function updateJourneyTypeIfPresent(error) {
  return function (state) {
    return state.update('journeyType', function (journeyType) {
      return channelIdToJourneyType(error.payload && error.payload.channelId) || journeyType;
    });
  };
}
function emitUserAuthNMethod(error) {
  userAuthNMethod$.next(error.payload && error.payload.userAuthNMethod);
}